import React, { useState } from 'react';
import PropTypes from "prop-types";
import style from './EuleriagymBalanceEvaluationResult.module.sass';
import BalanceOccupation from '../../../icons/BalanceOccupation';
import LeftRightChooser from '../../DailySequence/ExerciseSequence/ExerciseSequenceChart/LeftRightChooser/LeftRightChooser';
import EuleriagymMonodimensionalBalanceChart from './EuleriagymMonodimensionalBalanceChart/EuleriagymMonodimensionalBalanceChart';
import EuleriagymBidimensionalBalanceChart from './EuleriagymBidimensionalBalanceChart/EuleriagymBidimensionalBalanceChart';

function EuleriagymBalanceEvaluationResult(props) {
  const {
    anteroPosteriorChart,
    bidimensionalChart,
    duration,
    maxDeviation,
    midLateralChart,
    percentages,
    rms,
    sideChooser,
    sides,
    sway
  } = props;

  const [enableLeft, setLeftEnable] = useState(true);
  const [enableRight, setRightEnable] = useState(true);

  const measureUnit = (unit) => {
    switch(unit) {
      case "%":
        return (
          <span className={style.measureUnit}>%</span>
        )
      case "cm2":
        return (
          <span className={style.measureUnit}>cm<sup>2</sup></span>
        )
      default:
        return (
          <span className={style.measureUnit}>cm</span>
        )
    }
  }
  const percentagesRows = () => {
    return percentages.values.map((percentage, index) => {
      return (
        <div className={style.resultPercentageRow} key={index}>
          <div className={style.icon}>
            <BalanceOccupation quarter={percentage.quarter} />
          </div>
          {tableSidedValues(percentage.values, "%")}
        </div>
      )
    })
  }

  const tableSidedValues = (values, unit = "cm") => {
      console.log("values");
      console.log(values);
      console.log(sides[0]);  
    if(values.length == 2) {
      return values.map((value, index) => {
        return (
          <div
            key={index}
            className={tableValueClass(index)}
          >
            {value}
            {measureUnit(unit)}
          </div>
        )
      })
    }  else if( sides[0]<3 ){
      
      return (
        <div className={sides[0] === 0 ? style.leftValue : style.rightValue}>
          {values[0]}
          {measureUnit(unit)}
        </div>
      )
    }
    
    else {
      return (
        <div className={style.value}>
          {values[0]}
          {measureUnit(unit)}
        </div>
      )
    }
  }

  const tableValueClass = (index) => {
    let valueClass = {};

    if(index == 0) {
      if(enableLeft) {
        valueClass = style.leftValue
      } else {
        valueClass = `${style.leftValue} ${style.disabled}`
      }
    } else {
      if(enableRight) {
        valueClass = style.rightValue
      } else {
        valueClass = `${style.rightValue} ${style.disabled}`
      }
    }
    return valueClass
  }

  return (
    <>
      {sideChooser.isMonopodalic && sides.length == 2 &&
        <div className={style.sideChooserRow}>
          <div className={style.side} style={{marginRight: "3px"}}>{sideChooser.sideLabel}:</div>
          <LeftRightChooser
            leftText={sideChooser.sides[0]}
            rightText={sideChooser.sides[1]}
            onEnableLeft={setLeftEnable}
            onEnableRight={setRightEnable}
            isEuleriagym={true}
          />
        </div>
      }
      {sideChooser.isMonopodalic && sides.length == 1 &&
        <div className={style.sideChooserRow}>
          <div className={style.side}>
            <span>{sideChooser.sideLabel}: </span>
            {sides[0] == 0 && <span className={style.left}>{sideChooser.sides[sides[0]]}</span>}
            {sides[0] == 1 && <span className={style.right}>{sideChooser.sides[sides[0]]}</span>}
          </div>
        </div>
      }
      <div className="row" style={sideChooser.isMonopodalic ? {marginBottom: "35px"} : {marginBottom: "35px", paddingTop: "35px"}}>
        <div className="col-4">
          <div className={style.resultInfoRow}>
            <div className={style.label}>
              {duration.label}
              </div>
            <div className={`${style.values} ${style.duration}`}>
              <div className={style.value}>{duration.value}</div>
            </div>
          </div>
          <div className={style.resultInfoRow}>
            <div className={style.label}>
              {sway.label}
              </div>
            <div className={`${style.values} ${style.sway}`}>
              {tableSidedValues(sway.values, "cm2")}
            </div>
          </div>
          <div className={style.resultInfoRow}>
            <div className={style.label}>
              {rms.label}
              </div>
            <div className={`${style.values} ${style.rms}`}>
              {tableSidedValues(rms.values)}
            </div>
          </div>
        </div>
        <div className="col-8">
          <div className={`${style.resultInfoRow} ${style.forTitle}`}>
            <div className={style.title}>{maxDeviation.label}</div>
          </div>
          <div className='row'>
            <div className="col-6">
              <div className={`${style.resultInfoRow} ${style.noTopBorder}`}>
                <div className={style.label}>
                  {maxDeviation.forward.label}
                </div>
                <div className={style.values}>
                  {tableSidedValues(maxDeviation.forward.values)}
                </div>
              </div>
              <div className={style.resultInfoRow}>
                <div className={style.label}>
                  {maxDeviation.behind.label}
                </div>
                <div className={style.values}>
                  {tableSidedValues(maxDeviation.behind.values)}
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className={`${style.resultInfoRow} ${style.noTopBorder}`}>
                <div className={style.label}>
                  {maxDeviation.right.label}
                </div>
                <div className={style.values}>
                  {tableSidedValues(maxDeviation.right.values)}
                </div>
              </div>
              <div className={style.resultInfoRow}>
                <div className={style.label}>
                  {maxDeviation.left.label}
                </div>
                <div className={style.values}>
                  {tableSidedValues(maxDeviation.left.values)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-8 d-flex justify-content-end'>
          <EuleriagymBidimensionalBalanceChart
            axisTitles={bidimensionalChart.axisTitles}
            clampedData={bidimensionalChart.clampedData}
            colors={bidimensionalChart.colors}
            data={bidimensionalChart.data}
            labels={bidimensionalChart.labels}
            enableLeft={sideChooser.isMonopodalic && sides.length == 2 ? enableLeft : null}
            enableRight={sideChooser.isMonopodalic && sides.length == 2 ? enableRight : null}
          />
        </div>
        <div className='col-4 d-flex flex-column align-items-end'>
          <div style={{width: "85%"}}>
            <div className={`${style.resultInfoRow} ${style.forTitle}`}>
              <div className={style.title}>{percentages.label}</div>
            </div>
            {percentagesRows()}
          </div>
        </div>
      </div>
      {anteroPosteriorChart &&
        <div className="row">
          <EuleriagymMonodimensionalBalanceChart
            colors={anteroPosteriorChart.colors}
            clampedData={anteroPosteriorChart.clampedData}
            data={anteroPosteriorChart.data}
            directions={anteroPosteriorChart.directions}
            enableLeft={sideChooser.isMonopodalic && sides.length == 2 ? enableLeft : null}
            enableRight={sideChooser.isMonopodalic && sides.length == 2 ? enableRight : null}
            labels={anteroPosteriorChart.labels}
            title={anteroPosteriorChart.title}
          />
        </div>
      }
      {midLateralChart &&
        <div className="row">
          <EuleriagymMonodimensionalBalanceChart
            colors={midLateralChart.colors}
            clampedData={midLateralChart.clampedData}
            data={midLateralChart.data}
            directions={midLateralChart.directions}
            enableLeft={sideChooser.isMonopodalic && sides.length == 2 ? enableLeft : null}
            enableRight={sideChooser.isMonopodalic && sides.length == 2 ? enableRight : null}
            labels={midLateralChart.labels}
            title={midLateralChart.title}
          />
        </div>
      }
    </>
  )
}

EuleriagymBalanceEvaluationResult.propTypes = {
  duration: PropTypes.object,
  maxDeviation: PropTypes.object,
  percentages: PropTypes.object,
  rms: PropTypes.object,
  sideChooser: PropTypes.object,
  sides: PropTypes.array,
  sway: PropTypes.object
}

export default EuleriagymBalanceEvaluationResult;